export function resolveAssigneeProfile(assigneeId, userStore) {
    if (assigneeId == null) {
        return null;
    }

    return userStore.getUserProfileById(assigneeId) ?? { id: assigneeId };
}

export function syncQuickConversationAssignmentFromTeamStore({
    invitationStore,
    teamStore,
    userStore,
}) {
    if (!invitationStore.has_fetched_members_with_role_from_quick_conversation) {
        return;
    }

    if (teamStore.assigned == null) {
        invitationStore.quick_conversation_assigned_user = null;
        invitationStore.quick_conversation_assigner_profile_id = null;

        return;
    }

    invitationStore.quick_conversation_assigned_user = resolveAssigneeProfile(
        teamStore.assigned,
        userStore,
    );
    invitationStore.quick_conversation_assigner_profile_id =
        teamStore.assigner ?? null;
}

export function reconcileQuickConversationAssignmentWithTeamStore({
    invitationStore,
    teamStore,
    userStore,
}) {
    if (!invitationStore.has_fetched_members_with_role_from_quick_conversation) {
        return null;
    }

    const teamAssigneeId = teamStore.assigned;
    const quickAssigneeId =
        invitationStore.quick_conversation_assigned_user?.id ?? null;
    const quickAssignerId =
        invitationStore.quick_conversation_assigner_profile_id ?? null;
    const teamHasAssignee = teamAssigneeId != null;
    const quickHasAssignee = quickAssigneeId != null;

    if (
        teamHasAssignee &&
        (!quickHasAssignee ||
            Number(teamAssigneeId) !== Number(quickAssigneeId))
    ) {
        syncQuickConversationAssignmentFromTeamStore({
            invitationStore,
            teamStore,
            userStore,
        });

        return resolveAssigneeProfile(teamAssigneeId, userStore);
    }

    if (quickHasAssignee && !teamHasAssignee) {
        const assigneeProfile = invitationStore.quick_conversation_assigned_user;

        teamStore.assignedTo(assigneeProfile, quickAssignerId);
        syncQuickConversationAssignmentFromTeamStore({
            invitationStore,
            teamStore,
            userStore,
        });

        return assigneeProfile;
    }

    if (teamHasAssignee && quickHasAssignee) {
        const assigneeProfile = resolveAssigneeProfile(teamAssigneeId, userStore);
        const resolvedAssignerId = teamStore.assigner ?? quickAssignerId;

        teamStore.assignedTo(assigneeProfile, resolvedAssignerId);
        syncQuickConversationAssignmentFromTeamStore({
            invitationStore,
            teamStore,
            userStore,
        });

        return assigneeProfile;
    }

    invitationStore.quick_conversation_assigned_user = null;
    invitationStore.quick_conversation_assigner_profile_id = null;

    return null;
}
